export default __webpack_public_path__ + "static/media/credit-card.6e0417d3.jpeg";